import React from 'react';
import { PropTypes } from 'prop-types';

import { isEmpty } from 'utils/types';
import routes from 'utils/routes';

import FilterUser from 'components/orders/Filters/Filters/Users';
import FilterDates from 'components/orders/Filters/Filters/Dates';

const routesToActiveFilter = [routes.orders.previous, routes.orders.search];

const Filters = ({
  t,
  className,
  pathname,
  type,
  users,
  setUserFilter,
  isFetching,
  user,
  numberOfOrders,
}) => (
  <div className={className}>
    <div className="input">
      {!isEmpty(users) && users.length > 1 && (
        <FilterUser
          t={t}
          users={users}
          setUserFilter={setUserFilter}
          user={user}
        />
      )}
      {routesToActiveFilter.indexOf(pathname) >= 0 && <FilterDates t={t} />}
    </div>
  </div>
);

Filters.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  t: PropTypes.func,
  users: PropTypes.string,
  pathname: PropTypes.string,
  setUserFilter: PropTypes.func,
  user: PropTypes.number,
  numberOfOrders: PropTypes.number,
  isFetching: PropTypes.bool,
};

Filters.defaultProps = {
  className: '',
  type: '',
  t: () => {},
  users: '',
  pathname: '',
  setUserFilter: () => {},
  user: false,
  isFetching: false,
  numberOfOrders: 0,
};

export default Filters;
